// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chat-bubble-locked"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 14.6624 3.04042 17.0817 4.73686 18.8737L3 22H12Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M8.49805 11.5H15.498V16H8.49805V11.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 14.6624 3.04042 17.0817 4.73686 18.8737L3 22H12Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M9.74951 11.5V9.75C9.74951 8.50736 10.7569 7.5 11.9995 7.5C13.2422 7.5 14.2495 8.50736 14.2495 9.75V11.5M8.49805 11.5H15.498V16H8.49805V11.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChatBubbleLockedIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chat-bubble-locked',
    ref,
    icon: element,
  },
));

ChatBubbleLockedIcon.displayName = 'ChatBubbleLockedIcon';

export default ChatBubbleLockedIcon;
